import { REMPLISSAGE, TEXTE_SECONDAIRE } from '../theme';

// Pastille de statut réseau/synchro réutilisée dans l'en-tête, la barre d'action de la saisie et
// l'écran de synchronisation : une capsule discrète, qui informe sans jamais interrompre.
export default function StatusBadge({ point, texte, style }) {
  return (
    <div
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 8,
        height: 36,
        padding: '0 14px',
        borderRadius: 18,
        background: REMPLISSAGE,
        fontSize: 14,
        fontWeight: 600,
        color: TEXTE_SECONDAIRE,
        whiteSpace: 'nowrap',
        ...style,
      }}
    >
      <span style={{ width: 8, height: 8, borderRadius: '50%', background: point, flex: 'none', boxShadow: `0 0 0 3px color-mix(in srgb, ${point} 22%, transparent)` }} />
      {texte}
    </div>
  );
}
